// import { motion } from "framer-motion";
// import { useEffect, useState, useRef } from "react";

// const WaveAmplifier = ({ amplitude = 2, videoRef }) => {
//   const bars = Array.from({ length: 20 }, (_, i) => i);
//   const [levels, setLevels] = useState(bars.map(() => 5));
//   const audioContextRef = useRef(null);
//   const analyserRef = useRef(null);
//   const dataArrayRef = useRef(null);
//   const sourceRef = useRef(null);

//   useEffect(() => {
//     if (!videoRef?.current) return;
    
//     const initAudio = () => {
//       if (!audioContextRef.current) {
//         audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
//         analyserRef.current = audioContextRef.current.createAnalyser();
//         analyserRef.current.fftSize = 64;
//         dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
//       }

//       const audioContext = audioContextRef.current;
//       const analyser = analyserRef.current;

//       if (!sourceRef.current && videoRef.current.captureStream) {
//         const stream = videoRef.current.captureStream();
//         const audioSource = audioContext.createMediaStreamSource(stream);
//         audioSource.connect(analyser);
//         sourceRef.current = audioSource;
//       }

//       const updateLevels = () => {
//         analyser.getByteFrequencyData(dataArrayRef.current);
//         setLevels(bars.map((_, i) => {
//           const rawLevel = (dataArrayRef.current[i % dataArrayRef.current.length] / 255) * amplitude * 20;
//           // Cap the height to a maximum value (e.g., 20)
//           return Math.min(60, Math.max(5 , rawLevel));
//         }));
//         requestAnimationFrame(updateLevels);
//       };

//       updateLevels();
//     };

//     if (audioContextRef.current?.state === "suspended") {
//       audioContextRef.current.resume().then(initAudio);
//     } else {
//       initAudio();
//     }

//     return () => {
//       if (sourceRef.current) {
//         sourceRef.current.disconnect();
//         sourceRef.current = null;
//       }
//     };
//   }, [videoRef, amplitude]);

//   return (
//     <div className="flex gap-1 items-center h-6 me-4">
//       {bars.map((bar, index) => (
//         <motion.div
//           key={bar}
//           className="w-1 h-6 bg-[#FA3532] rounded "
//           animate={{ height: levels[index] }}
//           transition={{ duration: 0.1, ease: "easeInOut" }}
//         />
//       ))}
//     </div>
//   );
// };

// export default WaveAmplifier;


import { motion } from "framer-motion";
import { useEffect, useState, useRef } from "react";

const WaveAmplifier = ({ stream, amplitude = 2 }) => {
  const bars = Array.from({ length: 20 }, (_, i) => i);
  const [levels, setLevels] = useState(bars.map(() => 5));
  const audioContextRef = useRef(null);
  const analyserRef = useRef(null);
  const dataArrayRef = useRef(null);
  const sourceRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    if (!stream) {
      console.warn("No stream provided to WaveAmplifier");
      return;
    }

    const initAudio = async () => {
      try {
        if (!audioContextRef.current) {
          audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
          analyserRef.current = audioContextRef.current.createAnalyser();
          analyserRef.current.fftSize = 64;
          dataArrayRef.current = new Uint8Array(analyserRef.current.frequencyBinCount);
        }

        const audioContext = audioContextRef.current;
        const analyser = analyserRef.current;

        if (!sourceRef.current && stream.getAudioTracks().length > 0) {
          const audioSource = audioContext.createMediaStreamSource(stream);
          audioSource.connect(analyser);
          sourceRef.current = audioSource;
          console.log("WaveAmplifier: Audio source connected");
        } else {
          console.warn("WaveAmplifier: No audio tracks available in stream");
          return;
        }

        const updateLevels = () => {
          if (!analyserRef.current || !dataArrayRef.current) return;
          analyserRef.current.getByteFrequencyData(dataArrayRef.current);
          setLevels(
            bars.map((_, i) => {
              const rawLevel = (dataArrayRef.current[i % dataArrayRef.current.length] / 255) * amplitude * 20;
              return Math.min(60, Math.max(5, rawLevel));
            })
          );
          animationFrameRef.current = requestAnimationFrame(updateLevels);
        };

        if (audioContext.state === "suspended") {
          audioContext.resume().then(() => {
            console.log("WaveAmplifier: AudioContext resumed");
            updateLevels();
          });
        } else {
          updateLevels();
        }
      } catch (error) {
        console.error("WaveAmplifier: Error initializing audio:", error);
      }
    };

    // Initialize audio only if stream is available and has audio tracks
    if (stream && stream.getAudioTracks().length > 0) {
      initAudio();
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
        animationFrameRef.current = null;
      }
      if (sourceRef.current) {
        sourceRef.current.disconnect();
        sourceRef.current = null;
      }
      if (audioContextRef.current) {
        audioContextRef.current.close().catch((err) => console.error("WaveAmplifier: Error closing AudioContext:", err));
        audioContextRef.current = null;
      }
    };
  }, [stream, amplitude]);

  return (
    <div className="flex gap-1 items-center h-6 me-4">
      {bars.map((bar, index) => (
        <motion.div
          key={index}
          className="w-1 h-6 bg-[#FA3532] rounded"
          animate={{ height: levels[index] }}
          transition={{ duration: 0.1, ease: "easeInOut" }}
        />
      ))}
    </div>
  );
};

export default WaveAmplifier;